/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import { BfAppContext, BfPageStore, PageResDTO, newEqualCondition, newSortAsc, newSortDesc } from '@tw/tw-runtime';
import {
  ProductDocGoodsRestApiService,
  ProductGoodsDTO,
  ProductGoodsRestApiService,
  ProductOnGoingWelfareModel
} from '@tw/clvip-api-gen';

import { CommonStore } from '@/app/core/store/common/common-store';
import { GiftGiftHomePageStoreState } from './type';
import { ROUTE_NAMES } from '@/app/navigation/route-names';

export class GiftGiftHomePageStore extends BfPageStore<GiftGiftHomePageStoreState> {
  // 商品service
  private productGoodsService: ProductGoodsRestApiService;

  // // 活动service
  // private welfareService: ProductWelfareRestApiService;
  // // 商品service
  // private productResetService: ProductProductRestApiService;
  // // 订单serivce
  // private orderService: SaleOrderRestApiService;

  private curActivity: ProductOnGoingWelfareModel;

  constructor() {
    super({
      pluginOptions: {
        devTools: {
          name: 'gift/gift-home-page'
        }
      }
    });
    const api = BfAppContext.getInstance().getApiService();
    this.productGoodsService = new ProductGoodsRestApiService(api);
    // this.welfareService = new ProductWelfareRestApiService(api);
    // this.productResetService = new ProductProductRestApiService(api);
    // this.orderService = new SaleOrderRestApiService(api);
  }

  // 初始化
  async onLoad(): Promise<void> {
    this.setLoading(true);
    // 正在进行的活动 ProductWelfareDTO
    this.curActivity = await CommonStore.getInstance().getCurrentActivity();
    console.log('currentActivities', this.curActivity);

    if (!this.curActivity) {
      return;
    }

    // 获取推荐商品
    const conditions = [CommonStore.getInstance().getAuditPassCondition()];
    conditions.push(newEqualCondition(ProductGoodsRestApiService.IS_RECOMMAND, true));
    conditions.push(newEqualCondition(ProductGoodsRestApiService.WELFARE, this.curActivity.id));
    const recommendGoods = await this.productGoodsService.query({
      noPaging: true,
      conditions: conditions,
      sorts: [newSortDesc(ProductDocGoodsRestApiService.PRICE)]
    });

    console.log('recommendGoods', recommendGoods);

    this.setState({
      recommendGoods: recommendGoods.rows
    });

    this.setLoading(false);
  }

  /**
   * 列表点击事件
   * @param item
   */
  async onGoodClick(item: ProductGoodsDTO) {
    console.log('onGoodClick', item);

    this.routeService.push({
      path: ROUTE_NAMES.GiftGiftInfo,
      query: {
        id: item.id,
        mode: 'edit'
      }
    });
  }

  onBirthdayPress = async () => {
    console.log('onBirthdayPress');
    window.wx.miniProgram.navigateTo({
      url: '/pages/proxy-page/ProxyPage?appId=wxb182fcbf3023cc5d&title=华泽微福',
      success: function (res) {
        console.log('跳转成功', res);
      },
      fail: function (res) {
        // 跳转失败后的回调函数
        console.log('跳转失败后的回调函数', res);
      }
    });
  };

  onBirthday2Press = async () => {
    console.log('onBirthday2Press');
    window.wx.miniProgram.navigateTo({
      url: '/pages/proxy-page/ProxyPage?appId=wx2c7270f92d91dd23&title=华泽微福',
      success: function (res) {
        console.log('跳转成功', res);
      },
      fail: function (res) {
        // 跳转失败后的回调函数
        console.log('跳转失败后的回调函数', res);
      }
    });
  };

  onYyfPress() {
    window.wx.miniProgram.navigateTo({
      url: `/pages/proxy-page/ProxyPage?appId=wxa988f56feaaf3430&title=烨旖梵网上商城&path=${encodeURIComponent('pages/home/dashboard/index')}`,
      success: function (res) {
        console.log('跳转成功', res);
      },
      fail: function (res) {
        // 跳转失败后的回调函数
        console.log('跳转失败后的回调函数', res);
      }
    });
  }
}
